//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
/** Icons Import */
import WOR_BASIC from './WOR_BASIC';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import { setStartDate, setEndDate } from '../../../../Reducer/SearchReducer';
import dayjs from 'dayjs';
//#endregion

// 년도 목록 생성 (현재년도 기준 ±10년)
const buildYearList = () => {
  const currentYear = dayjs().year();
  const years = [];
  for (let y = currentYear + 1; y >= currentYear - 10; y--) {
    years.push({ value: String(y), name: `${y}년` });
  }
  return years;
};

function WOR_BASICF(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
const [value, setValue] = React.useState(0);
   // 탭 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    else if (newValue === 2) setSearchClick3(true);
    setValue(newValue);
  };

  // 탭0 조건용 (회사/사업장/년도)
  const [selectedYear, setSelectedYear] = useState(String(dayjs().year()));
  const yearList = buildYearList();

  // 탭별 클릭 플래그 (F에서 useEffect로 처리)
  const [filterClick1, setFilterClick1] = useState(false);
  const [filterClick2, setFilterClick2] = useState(false);
  const [searchClick1, setSearchClick1] = useState(false);
  const [searchClick2, setSearchClick2] = useState(false);
  const [filterClick3, setFilterClick3] = useState(false);
  const [searchClick3, setSearchClick3] = useState(false);
  const [saveClick3, setSaveClick3] = useState(false);
  const [deleteClick3, setDeleteClick3] = useState(false);
  const [printClick3, setPrintClick3] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리
  const startDate = searchInfo.startDate;
  const endDate = searchInfo.endDate;

  const handleStartDateChange = (newStart) => {
    const newStartDate = dayjs(newStart).format('YYYY-MM-DD');
    let updatedEnd = searchInfo.endDate;

    // 시작일이 종료일보다 크거나 같으면 종료일도 시작일로 맞춤
    if (!dayjs(newStartDate).isBefore(dayjs(updatedEnd))) {
      updatedEnd = newStartDate;
      dispatch(setEndDate(updatedEnd));
    }

    dispatch(setStartDate(newStartDate));
  };

  const handleEndDateChange = (newEnd) => {
    const newEndDate = dayjs(newEnd).format('YYYY-MM-DD');
    let updatedStart = searchInfo.startDate;

    // 종료일이 시작일보다 빠르면 시작일을 종료일로 맞춤
    if (dayjs(newEndDate).isBefore(dayjs(updatedStart))) {
      updatedStart = newEndDate;
      dispatch(setStartDate(updatedStart));
    }

    dispatch(setEndDate(newEndDate));
  };

  // 최초 로딩 시 탭0(작업환경측정) getWorBasicR2 조회 트리거
  useEffect(() => {
    setSearchClick1(true);
  }, []);
  //#endregion

  //#endregion

  //#region 나머지 함수
  // 서식 다운로드
  const DownloadLogic1 = async () => {
    try {
      const filePath = 'DocumentForm/작업환경측정_예시.hwp';
      const fileName = '작업환경측정_예시.hwp';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 서식 다운로드 완료.`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <WOR_BASIC
        value={value}
        HandleChange={HandleChange}
        gridId1="grid1"
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        searchInfo={searchInfo}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        yearList={yearList}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        filterClick3={filterClick3}
        setFilterClick3={setFilterClick3}
        searchClick3={searchClick3}
        setSearchClick3={setSearchClick3}
        saveClick3={saveClick3}
        setSaveClick3={setSaveClick3}
        deleteClick3={deleteClick3}
        setDeleteClick3={setDeleteClick3}
        printClick3={printClick3}
        setPrintClick3={setPrintClick3}
        DownloadLogic1={DownloadLogic1}
        DownloadLogic2={DownloadLogic2}
      />
    </div>
  );
}

export default WOR_BASICF;
